import * as React from 'react';
import classNames from 'classnames';
import * as Utils from '../Utils';
import { Redirect } from 'react-router';
import DurationButtons from './DurationButtons';
import QRCode from './QRCode';

export interface ITimerOptions {
  duration: number;
  startedMs: number;
  notification: boolean;
  notificationText?: string;
  getHook?: string;
  timerCode?: number;
  myTimerCode?: number;
}

interface ITimerOptionsState {
  notification: boolean;
  notificationText: string;
  getHook: string;
  getHookvisible: boolean;
  timerCode?: number;
  myTimerCode: number;
  shareMyTimer: boolean;
  qrCode?: string;
  start: boolean;
}

const DEFAULT_HOOK = "https://yourdomain.com/hook?param=42";
const DEFAULT_NOTIFICATION_TEXT = "Time is over!";

export default class TimerOptions extends React.Component<{}, ITimerOptionsState> {

  constructor(props: {}) {
    super(props);
    this.state = {
      getHook: window.localStorage.getItem("getHook") || DEFAULT_HOOK,
      getHookvisible: window.localStorage.getItem("getHookvisible") === "true",
      myTimerCode: this.getMyTimerCodeFromLocalStorage(),
      notification: Notification.permission === "granted",
      notificationText: window.localStorage.getItem("notificationText") || DEFAULT_NOTIFICATION_TEXT,
      qrCode: undefined,
      shareMyTimer: window.localStorage.getItem("shareMyTimer") === "true",
      start: false,
      timerCode: undefined,
    }
    this.notificationChanged = this.notificationChanged.bind(this);
    this.hookChanged = this.hookChanged.bind(this);
    this.hookSwitchChanged = this.hookSwitchChanged.bind(this);
    this.notificationTextChanged = this.notificationTextChanged.bind(this);
    this.timerCodeChanged = this.timerCodeChanged.bind(this);
    this.shareMyTimerChanged = this.shareMyTimerChanged.bind(this);
    this.myTimerCodeChanged = this.myTimerCodeChanged.bind(this);
    this.onStart = this.onStart.bind(this);
  }

  public render() {
    if (this.state.start) {
      if (this.state.timerCode && this.state.timerCode.toString().length === 6) {
        return <Redirect to={`/timer/remote/${this.state.timerCode}`} />;
      } else if (this.state.shareMyTimer) {
        return <Redirect to={`/timer/${this.state.myTimerCode}`} />;
      } else {
        return <Redirect to={`/timer/notshared`} />;
      }
    }
    return (
      <div className="container">
        <div className="row">
          <div className="col" />
          <div className="col">
            <h1 className="text-center">Interval</h1>
          </div>
          <div className="col" />
        </div>
        <div className="row">
          <div className="col" />
          <div className="col-lg-6 col-sm-12 text-center">
            <DurationButtons onStart={this.onStart} />
          </div>
          <div className="col" />
        </div>
        <div className="row mt-4">
          <div className="col" />
          <div className="col-lg-4 col-sm-12">
            <div className="custom-control custom-switch">
              <input
                id="notificationSwitch"
                type="checkbox"
                className="custom-control-input"
                checked={this.state.notification}
                onChange={this.notificationChanged}
              />
              <label className="custom-control-label" htmlFor="notificationSwitch">notification</label>
            </div>
            {this.state.notification ?
              <input
                className={classNames("form-control", "mb-4")}
                type="text"
                placeholder="Time is over!"
                value={this.state.notificationText}
                onChange={this.notificationTextChanged}
              />
              : null}
          </div>
          <div className="col" />
        </div>
        <div className="row">
          <div className="col" />
          <div className="col-lg-4 col-sm-12">
            <div className="custom-control custom-switch">
              <input
                id="hookSwitch"
                type="checkbox"
                className="custom-control-input"
                checked={this.state.getHookvisible}
                onChange={this.hookSwitchChanged}
              />
              <label className="custom-control-label" htmlFor="hookSwitch">call webhook (GET)</label>
            </div>
            {this.state.getHookvisible ?
              <input
                className={classNames("mb-4", "form-control")}
                type="text"
                placeholder="Default input"
                value={this.state.getHook}
                onChange={this.hookChanged}
              />
              : null}
          </div>
          <div className="col" />
        </div>
        <div className="row">
          <div className="col" />
          <div className="col-lg-4 col-sm-12">
            <div className="custom-control custom-switch">
              <input
                id="shareMyTimerSwitch"
                type="checkbox"
                className="custom-control-input"
                checked={this.state.shareMyTimer}
                onChange={this.shareMyTimerChanged}
              />
              <label className="custom-control-label" htmlFor="shareMyTimerSwitch">share the timer</label>
            </div>
            {this.state.shareMyTimer ?
              <>
                <input
                  className={classNames("form-control")}
                  type="number"
                  min="100000"
                  max="999999"
                  placeholder="Default input"
                  value={this.state.myTimerCode}
                  onChange={this.myTimerCodeChanged}
                />
                <QRCode myTimerCode={this.state.myTimerCode} />
              </>
              : null}
          </div>
          <div className="col" />
        </div>
        <div className="row">
          <div className="col" />
          <div className="col-lg-8 col-sm-12 text-center">
            <h3 className="mt-5">connect to a remote timer</h3>
          </div>
          <div className="col" />
        </div>
        <div className="row">
          <div className="col" />
          <div className="col-lg-2 col-sm-12">
            <input
              className={classNames("form-control form-control-lg", "mb-2")}
              type="text"
              placeholder="Timer code"
              value={this.state.timerCode || ""}
              onChange={this.timerCodeChanged}
            />
          </div>
          <div className="col" />
        </div>
      </div>
    );
  }

  private onStart() {
    this.setState({
      start: true
    })
  }

  private async notificationChanged(event: React.ChangeEvent<HTMLInputElement>) {
    const checked = event.currentTarget.checked;
    if (checked) {
      if (Notification.permission === "granted") {
        this.setState({
          notification: true
        });
      } else if (Notification.permission !== "denied") {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
          this.setState({
            notification: true
          })
        }
      }
    } else {
      this.setState({
        notification: false
      })
    }
  }

  private notificationTextChanged(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.currentTarget.value;
    this.setState({
      notificationText: value
    });
    window.localStorage.setItem("notificationText", value);
  }

  private hookSwitchChanged(event: React.ChangeEvent<HTMLInputElement>) {
    const checked = event.currentTarget.checked;
    this.setState({
      getHookvisible: checked
    });
    window.localStorage.setItem("getHookvisible", checked.toString());
  }

  private hookChanged(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.currentTarget.value;
    this.setState({
      getHook: value
    });
    window.localStorage.setItem("getHook", value);
  }

  private async shareMyTimerChanged(event: React.ChangeEvent<HTMLInputElement>) {
    const checked = event.currentTarget.checked;
    if (checked) {
      this.setState({
        shareMyTimer: checked
      });
    } else {
      this.setState({
        shareMyTimer: checked
      });
    }
    window.localStorage.setItem("shareMyTimer", checked.toString());
  }

  private async myTimerCodeChanged(event: React.ChangeEvent<HTMLInputElement>) {
    const value = event.currentTarget.value;
    const num = parseInt(value, 10);
    if (isNaN(num) || value.length !== 6) {
      return;
    }
    this.setState({
      myTimerCode: num,
    });
    window.localStorage.setItem("myTimerCode", num.toString());
  }

  private timerCodeChanged(event: React.ChangeEvent<HTMLInputElement>) {
    let value = event.currentTarget.value;
    let newVal;
    if (value !== undefined && value !== "") {
      value = value.replace(/\D/g, "").substr(0, 6);
      newVal = parseInt(value, 10);
    }
    this.setState({
      timerCode: newVal,
      start: (newVal !== undefined && !isNaN(newVal) && newVal.toString().length === 6)
    });
  }

  private getMyTimerCodeFromLocalStorage() {
    const timerCode = window.localStorage.getItem("myTimerCode");
    if (timerCode) {
      return parseInt(timerCode, 10)
    } else {
      const newCode = Utils.generateMyTimerCode();
      window.localStorage.setItem("myTimerCode", newCode.toString());
      return newCode;
    }
  }

}


// WEBPACK FOOTER //
// ./src/Timer/TimerOptions.tsx